import React from 'react'
import Flex from 'typescript-styled-flex'
import { withTranslation } from 'react-i18next'
import {
  FormGroup,
  NumberInput,
  Select,
  TextareaInput,
  TextInput,
} from '../../../components/FormBuilder'
import { Desktop } from '../../../components/MediaQuery'
import { ProvenancesModal } from '../../BookingCalendar/ReservationModal'
import { FeedingType } from '../../../models/Object'
import sanitizeInput from '../../../utils/InputFiltering'
import { withSize } from '../../../hooks/useSize'
import { CreatableSelectWithProvenances } from './Components'
import VisibilityControlled from './Components/VisibilityControlled'
import { withIsDesktop } from './withIsDesktop'

class OtherTab extends React.Component<any, any> {
  public constructor(props) {
    super(props)
  }

  public shouldComponentUpdate(nextProps: Readonly<any>): boolean {
    if (
      nextProps.isDesktop !== this.props.isDesktop ||
      nextProps.allowReservationEdit !== this.props.allowReservationEdit ||
      nextProps.type !== this.props.type ||
      nextProps.isSaving !== this.props.isSaving ||
      nextProps.size !== this.props.size
    ) {
      return true
    } else {
      return false
    }
  }

  public render(): React.ReactNode {
    const {
      isDesktop,
      t,
      toggleProvenancesModal,
      createProvenance,
      type,
      size,
      allowReservationEdit,
      isLite,
    } = this.props

    const onProvenanceCreate = option => {
      if (allowReservationEdit) {
        const sanitizedInput = sanitizeInput(
          option.value
            .replace(
              /([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
              '',
            )
            .trim(),
        )
        if (sanitizedInput) {
          option.value = sanitizedInput
          createProvenance(option)
        }
      } else {
        this.props.firePricingError()
      }
    }

    const onNewProvenance = () => {
      if (!this.props.isSaving) {
        if (allowReservationEdit) {
          toggleProvenancesModal(true)()
        } else {
          this.props.firePricingError()
        }
      }
    }

    return (
      <Flex
        row={isDesktop}
        column={!isDesktop}
        full={true}
        style={{
          height: 'auto',
          padding: isDesktop
            ? `${10 * size}px ${16 * size}px ${25 * size}px ${16 * size}px`
            : `${10 * size}px ${20 * size}px ${16 * size}px`,
        }}
      >
        <Flex column={true} style={{ flexGrow: 1, width: '100%' }}>
          <FormGroup.Render
            size={size}
            column={true}
            title={t('BBO_980_other')}
          >
            <Flex column={true}>
              <TextareaInput.ReduxField
                size={size}
                autoSize={true}
                name={'note'}
                label={t('reservation_note')}
                style={{ resize: 'none' }}
                wrapperStyle={{
                  maxWidth: '100%',
                  width: '100%',
                }}
                isSmallReservation={true}
              />
            </Flex>
            <VisibilityControlled field={'reservationSource'}>
              <Flex column={true}>
                <CreatableSelectWithProvenances
                  name={'provenances'}
                  size={size}
                  label={t('reservation_source')}
                  placeholder={t('select')}
                  style={{
                    fontWeight: 'bold',
                  }}
                  wrapperStyle={{
                    maxWidth: '100%',
                    width: '100%',
                  }}
                  customCreateMessage={t('notification_action_create_new')}
                  onIconClick={onNewProvenance}
                  createOption={onProvenanceCreate}
                  isSmallReservation={true}
                  noOptionsMessage={t('search_not_found')}
                />
                <ProvenancesModal />
              </Flex>
            </VisibilityControlled>

            <VisibilityControlled field={'residenceRegistration'}>
              <Flex column={true}>
                <Select.ReduxField
                  size={size}
                  name={'registration'}
                  label={t('reservation_registration')}
                  placeholder={t('select')}
                  style={{
                    fontWeight: 'bold',
                  }}
                  wrapperStyle={{
                    maxWidth: '100%',
                    width: '100%',
                  }}
                  isSmallReservation={true}
                >
                  <Select.Option value={'0'}>
                    {t('registration_none')}
                  </Select.Option>
                  <Select.Option value={'1'}>
                    {t('reservation_registration_checked_in')}
                  </Select.Option>
                  <Select.Option value={'2'}>
                    {t('reservation_registration_checked_out')}
                  </Select.Option>
                </Select.ReduxField>
              </Flex>
            </VisibilityControlled>

            <VisibilityControlled field={'feeding'}>
              <Flex column={true}>
                <Select.ReduxField
                  name={'feeding'}
                  size={size}
                  label={t('reservation_services')}
                  placeholder={t('select')}
                  style={{
                    fontWeight: 'bold',
                  }}
                  wrapperStyle={{
                    maxWidth: '100%',
                    width: '100%',
                  }}
                  isSmallReservation={true}
                >
                  <Select.Option value={FeedingType.WithoutFood}>
                    {t('reservation_services_type_ov')}
                  </Select.Option>
                  <Select.Option value={FeedingType.Breakfast}>
                    {t('reservation_services_type_bb')}
                  </Select.Option>
                  <Select.Option value={FeedingType.WithDinner}>
                    {t('reservation_services_type_hb')}
                  </Select.Option>
                  <Select.Option value={FeedingType.FullFood}>
                    {t('reservation_services_type_fb')}
                  </Select.Option>
                </Select.ReduxField>
              </Flex>
            </VisibilityControlled>

            <VisibilityControlled field={'doorCode'}>
              <Flex column={true}>
                <TextInput.ReduxField
                  name={'doorCode'}
                  size={size}
                  disabled={isLite}
                  withPopoverIcon={isLite}
                  labelStyle={{display: 'flex',gap: '8px'}}
                  label={t('door_code')}
                  wrapperStyle={{
                    maxWidth: '100%',
                    width: '100%',
                  }}
                  isSmallReservation={true}
                />
              </Flex>
            </VisibilityControlled>
          </FormGroup.Render>
        </Flex>
        <Desktop>
          <Flex
            style={{ flexBasis: `${25 * size}px`, minWidth: `${25 * size}px` }}
          />
        </Desktop>

        <Flex column={true} style={{ flexGrow: 1, width: '100%' }}>
          <VisibilityControlled field={'numberOfBeds'}>
            <FormGroup.Render
              size={size}
              column={true}
              title={t('number_of_beds')}
            >
              <Flex justifyBetween={true} alignEnd={true} row={true}>
                <NumberInput.ReduxField
                  name={'singleBeds'}
                  style={{ maxWidth: '100%', width: '100%' }}
                  label={t('number_of_beds_single')}
                  minValueForNumber={0}
                  maxValueForNumber={20}
                  size={size}
                  isSmallReservation={true}
                  inputStyle={{ minWidth: 0 }}
                />
                <NumberInput.ReduxField
                  name={'twinBeds'}
                  style={{ maxWidth: '100%', width: '100%' }}
                  label={t('number_of_beds_twin')}
                  minValueForNumber={0}
                  maxValueForNumber={8}
                  size={size}
                  isSmallReservation={true}
                  wrapperStyle={{ marginLeft: `${20 * size}px` }}
                  inputStyle={{ minWidth: 0 }}
                />
              </Flex>
            </FormGroup.Render>
          </VisibilityControlled>
        </Flex>
        <Desktop>
          <Flex
            style={{ flexBasis: `${25 * size}px`, minWidth: `${25 * size}px` }}
          />
        </Desktop>
        <Flex column={true} style={{ flexGrow: 1, width: '100%' }}>
          <VisibilityControlled field={'creationDate'}>
            {type === 'update' && (
              <FormGroup.Render
                size={size}
                column={true}
                title={t('BBO_980_information')}
              >
                <TextInput.ReduxField
                  name={'createDate'}
                  disabled={true}
                  size={size}
                  wrapperStyle={{
                    cursor: 'not-allowed',
                    maxWidth: '100%',
                    width: '100%',
                  }}
                  label={t('z677_creation_date')}
                  isSmallReservation={true}
                />
              </FormGroup.Render>
            )}
          </VisibilityControlled>
        </Flex>
      </Flex>
    )
  }
}

export default withIsDesktop(withTranslation()(withSize(OtherTab)))
